import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';



import { Producto } from './producto';

import { ProductoPrecio } from './productoPrecio';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  constructor(private http: HttpClient) { }



  getEtiqueta(){
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/',"^xa^cfa,50^fo100,100^fdHello World^fs^xz",{headers: headers});  
  }

 
  getProducto(id: string) {   
    
    return this.http.get<Producto[]>(environment.apiUrl+"/listarProducto/?idEmisor="+id);  
  }  

  getProductoInventario(id: string) {   
    
    return this.http.get<Producto[]>(environment.apiUrl+"/listarProductoInventario/?idEmisor="+id);  
  }  

  
  getProductoPorCodigo(codigo: string,id :string) {   
    console.log(environment.apiUrl+"/buscarProductoPorCodigo/?codigo="+codigo+"&id="+id);
    return this.http.get<Producto[]>(environment.apiUrl+"/buscarProductoPorCodigo/?codigo="+codigo+"&id="+id);  
  }  
  getProductoPorId(id:string) {  
    
    return this.http.get<Producto[]>(environment.apiUrl+"/buscarProductoPorId/?id="+id);  
  }  

  setActulizarProducto(productos: Producto[]){
    console.log(productos);
    return this.http.put<Producto>(environment.apiUrl+"/actulizarProducto",productos);
  }

  setActulizarProductoPrecio(productos: ProductoPrecio[]){
    console.log(productos);
    return this.http.put<string>(environment.apiUrl+"/actulizarPrecios",productos);
  }

  eliminarProducto(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarProducto/?id="+id);
  }

  eliminarPrecio(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarPrecio/?id="+id);
  }
  
  getProductoPrecio(producto: string, emisor: string) {   
    

    return this.http.get<ProductoPrecio[]>(environment.apiUrl+"/buscarProductoPrecio/?producto="+producto+"&emisor="+emisor);  
  }  
  buscarProductoPrecioUnidadProducto(unidad: number,producto: number) {   
    

    return this.http.get<ProductoPrecio[]>(environment.apiUrl+"/buscarProductoPrecioUnidadProducto/?unidad="+unidad+"&producto="+producto);  
  }  




  getEtiquetaVenta(producto:String,codigo:String,pvp2:String,pvp1:String) {
    let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
    const formData = new FormData();
    let zlp='CT~~CD,~CC^~CT~\n'+
    '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR4,4~SD10^JUS^LRN^CI0^XZ\n'+
    '^XA\n'+
    '^MMT\n'+
    '^LL0216\n'+
    '\n'+
    '^LS0\n'+
    '^BY1,3,43^FT50,66^BCN,,Y,N\n'+
    '^FD'+codigo+'^FS\n'+
    '^FT64,123^A0N,28,28^FH\^FD'+producto+'^FS\n'+
    '^FT64,165^A0N,28,28^FH\^FD'+pvp1+'^FS\n'+
    //'^FT224,121^A0N,25,24^FH\^FD'+pvp2+'^FS\n'+
    '^PQ1,0,1,Y^XZ';
    console.log(zlp);

    formData.append('file',zlp);
    return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/1.96x1.06/0/',formData ,{
      headers: { 'Accept':'application/pdf' }, responseType: 'blob'
    });
    
}



getEtiquetaVentaHerz(producto:String,codigo:String,pvp1:String,pvp2:String) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp=
  '^XA\n'+
  '~TA000\n'+
  '~JSN\n'+
 '^MNW\n'+
  '^MTT\n'+
  '^PON\n'+
  '^PMN\n'+
  '^LH0,0\n'+
  '^JMA\n'+
  '^PR5,5\n'+
  '~SD15\n'+
  '^JUS\n'+
  '^LRN\n'+
  '^CI27\n'+
  '^PA0,1,1,0\n'+
  '^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW248\n'+
  '^LL200\n'+
  '^LS0\n'+
  '^BY2,3,69^FT40,77^BCN,,Y,N\n'+
  '^FD'+codigo+'^FS\n'+
  '^FT16,161^A0N,17,16^FH\^FD'+producto+'^FS\n'+
  '^FT136,129^A0N,25,24^FH\^FD'+pvp1+'^FS\n'+
  '^FT56,129^A0N,25,24^FH\^FD'+pvp2+'^FS\n'+
  '^PQ1,0,1,Y^XZ';
  console.log(zlp);

  formData.append('file',zlp);
  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/1.37x0.984/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
  
}

getEtiquetaVentaImpoHerrague(producto: string, codigo: string, pvp2: string, pvp1: string) {
  const formData = new FormData();

  let zlp =
    'CT~~CD,~CC^~CT~\n' +
    '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR4,4~SD10^JUS^LRN^CI0^XZ\n' +
    '^XA\n' +
    '^MMT\n' +
    '^LL0216\n' +
    '^LS0\n' +
    '^BY3,3,100^FT50,120^BCN,,Y,N\n' +
    '^FD' + codigo + '^FS\n' +

    // Producto: letra más pequeña
    '^FT45,210^A0N,23,23^FH\\^FD' + producto + '^FS\n' +

    // Precio (puedes ajustar si también quieres más pequeño)
    '^FT64,180^A0N,28,28^FH\\^FD' + pvp1 + '^FS\n' +

    '^PQ1,0,1,Y^XZ';

  console.log(zlp);

  formData.append('file', zlp);

  return this.http.post(
    'http://api.labelary.com/v1/printers/8dpmm/labels/1.96x1.06/0/',
    formData,
    {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
    }
  );
}



getEtiquetaVentaPink(producto:String,codigo:String,pvp1:String,pvp2:String) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp=
  
  '^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW296\n'+
  '^LL0200\n'+
  '^LS0\n'+
  '^BY1,3,47^FT24,72^B3N,,Y,N\n'+
  '^FD'+codigo+'^FS\n'+
  '^FT16,131^A0N,20,20^FH\^FD'+producto+'^FS\n'+
  '^FT117,161^A0N,25,25^FH\^FD'+pvp1+'^FS\n'+
  '^FT16,161^A0N,25,25^FH\^FD'+pvp2+'^FS\n'+
  '^PQ1,0,1,Y^XZ';
  console.log(zlp);

  formData.append('file',zlp);
  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/1.45669x0.984252/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
  
}



getEtiquetaVentaJUMP(producto:String,codigo:String,pvp1:String,pvp2:String) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp=
  
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR4,4~SD10^JUS^LRN^CI0^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW200\n'+
  '^LL0280\n'+
  '^LS0\n'+

  '^BY1,3,41^FT10,75^BCN,,Y,N\n'+
  '^FD'+codigo+'^FS\n'+
  '^FT10,124^A0N,14,14^FH\^FD'+producto+'^FS\n'+
  '^FT12,180^A0N,22,21^FH\^FD'+pvp2+'^FS\n'+
  '^PQ1,0,1,Y^XZ';
  console.log(zlp)

  

  formData.append('file',zlp);
  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/0.984252x1.37795/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
  
}





}
